import React, { useState, useEffect } from "react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { fetchCoa } from "../../../WorkSpace/Components/ApiServices/apiHandler";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import Breadcrumb from "../../components/Breadcrumb";

const Listing = () => {
  const { id } = useParams();
  const history = useHistory();
  const location = useLocation();
  const { coaName: passedCoaName, coaLedgers: passedCoaLedgers } = location.state || {};
  const [coaData, setCoaData] = useState(passedCoaLedgers || []);
  const [loading, setLoading] = useState(!passedCoaLedgers);

  const formatNumber = (num) => {
    if (num === null || num === undefined || num === "" || isNaN(Number(num))) return "-";
    const val = Number(num);
    if (val === 0) return "0";
    if (val < 0) {
      return `(${Math.abs(val).toLocaleString("en-IN")})`;
    }
    return val.toLocaleString("en-IN");
  };

  useEffect(() => {
    // If we already have the data from the router state, no need to fetch!
    if (passedCoaLedgers && passedCoaLedgers.length > 0) {
      setLoading(false);
      return;
    }

    const getData = async () => {
      try {
        const res = await fetchCoa();
        let dataToUse = res?.data;
        
        let projectsArray = [];
        if (dataToUse && dataToUse.coa && Array.isArray(dataToUse.coa)) {
          projectsArray = dataToUse.coa;
        } else if (Array.isArray(dataToUse)) {
          projectsArray = dataToUse;
        }

        const projectData = projectsArray.find(p => p.project_id === id || p._id === id);
        
        if (projectData && Array.isArray(projectData.coa)) {
          setCoaData(projectData.coa);
        } else {
          setCoaData([]);
        }
      } catch (err) {
        console.error("Failed to fetch COA, using mock", err);
        //setCoaData(coaDataMock[0]?.coa || []);
      } finally {
        setLoading(false);
      }
    };
    getData();
  }, [id, passedCoaLedgers]);

  return (
    <div className="w-100" style={{ backgroundColor: "#f8f9f9", minHeight: "100vh", padding: "5px 20px 20px" }}>
      {/* Breadcrumbs */}
      <div style={{ padding: "0px", marginBottom: "5px" }}>
        <Breadcrumb
          addCls="bgTransprent"
          p0={true}
          items={[
            {
              label: "COA",
              link: "/dashboard",
              className: "nav_cnt_color clickable",
            },
            {
              label: passedCoaName || "COA Listing",
              link: "",
              className: "headerLable",
            },
          ]}
          headerActions={<></>}
        />
      </div>

      <style>
        {`
          .hide-scrollbar::-webkit-scrollbar {
            display: none;
          }
          .hide-scrollbar {
            -ms-overflow-style: none;
            scrollbar-width: none;
          }
          .table-bordered {
            border-collapse: collapse !important;
            border-spacing: 0 !important;
            border: none !important;
          }
          .table-bordered td {
            border: none !important;
            border-bottom: 1px solid #eaeeed !important;
            border-right: 1px solid #eaeeed !important;
          }
          .table-bordered th {
            border: none !important;
            border-bottom: 1px solid #eaeeed !important;
          }
          .table-bordered tbody tr td:last-child {
            border-right: none !important;
          }
          .table-bordered tbody tr:last-child td {
            border-bottom: none !important;
          }
        `}
      </style>

      {/* Table Container */}
      <div
        className="hide-scrollbar"
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "14px",
          border: "1px solid #CCD5D3",
          borderCollapse: "collapse",
          width: "100%",
         // boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.05)",
          overflowX: "auto",
          overflowY: "auto",
          maxHeight: "calc(100vh - 82px)"
        }}
      >
        {loading ? (
          <div style={{ padding: "20px" }}>Loading...</div>
        ) : (
          <table className="table table-bordered" style={{ width: "100%", whiteSpace: "nowrap", borderCollapse: "separate", borderSpacing: 0, margin: 0 }}>
            <thead>
              <tr>
                {[
                  "LEDGER CODE",
                  "NAME",
                  "FS GROUPING (CY)",
                  "NOTES GROUPING (CY)",
                  "SUB GROUPING (CY)",
                  "FS GROUPING (PY)",
                  "NOTES GROUPING (PY)",
                  "SUB GROUPING (PY)"
                ].map((heading, idx) => {
                  const isStickyCol = idx === 0 || idx === 1;
                  const getWidth = () => {
                    if (heading === "LEDGER CODE") return { minWidth: "160px", width: "160px" };
                    if (heading === "NAME") return { minWidth: "280px", width: "280px" };
                    if (heading === "FS GROUPING (CY)" || heading === "FS GROUPING (PY)") return { minWidth: "250px", width: "250px" };
                    if (heading === "NOTES GROUPING (CY)") return { minWidth: "400px", width: "400px" };
                    if (heading === "SUB GROUPING (CY)") return { minWidth: "430px", width: "430px" };
                    if (heading === "NOTES GROUPING (PY)") return { minWidth: "400px", width: "400px" };
                    if (heading === "SUB GROUPING (PY)") return { minWidth: "430px", width: "430px" };
                    return { minWidth: "200px", width: "auto" };
                  };
                  const colWidth = getWidth();
                  return (
                    <th
                      key={idx}
                      style={{
                        color: "#205a46",
                        textTransform: "uppercase",
                        fontSize: "14px",
                        fontWeight: "700",
                        padding: "10px 24px",
                        boxShadow: "inset 0 -1px 0 #eaeeed",
                        textAlign: "left",
                        position: "sticky",
                        top: 0,
                        backgroundColor: "#EFF7F0",
                        zIndex: isStickyCol ? 10 : 5,
                        left: idx === 0 ? 0 : (idx === 1 ? "160px" : "auto"),
                        minWidth: colWidth.minWidth,
                        width: colWidth.width,
                        whiteSpace: "nowrap",
                      }}
                    >
                      {heading}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {coaData.map((item, index) => (
                <tr key={index}>
                  <td style={{ color: "#111111", padding: "16px 24px", fontSize: "14px", fontWeight: "400", textAlign: "left", position: "sticky", left: 0, backgroundColor: "#ffffff", zIndex: 1, minWidth: "160px", width: "160px" }}>{item.ledger_code || "-"}</td>
                  <td style={{ color: "#111111", padding: "16px 24px", fontSize: "14px", fontWeight: "400", textAlign: "left", position: "sticky", left: "160px", backgroundColor: "#ffffff", zIndex: 1, minWidth: "280px", width: "280px", wordWrap: "break-word" }}>{item.ledger_name || "-"}</td>
                  <td style={{ color: "#111111", padding: "16px 24px", fontSize: "14px", fontWeight: "400", textAlign: "left", whiteSpace: "normal", minWidth: "220px", width: "220px", wordWrap: "break-word" }}>{item.map_data?.cy_map?.fs_grp || "-"}</td>
                  <td style={{ color: "#111111", padding: "16px 24px", fontSize: "14px", fontWeight: "400", textAlign: "left", whiteSpace: "normal", minWidth: "320px", width: "320px", wordWrap: "break-word" }}>{item.map_data?.cy_map?.note_grp || "-"}</td>
                  <td style={{ color: "#111111", padding: "16px 24px", fontSize: "14px", fontWeight: "400", textAlign: "left", whiteSpace: "normal", minWidth: "370px", width: "370px", wordWrap: "break-word" }}>{item.map_data?.cy_map?.sub_grp || "-"}</td>
                  <td style={{ color: "#111111", padding: "16px 24px", fontSize: "14px", fontWeight: "400", textAlign: "left", whiteSpace: "normal", minWidth: "220px", width: "220px", wordWrap: "break-word" }}>{item.map_data?.py_map?.fs_grp || "-"}</td>
                  <td style={{ color: "#111111", padding: "16px 24px", fontSize: "14px", fontWeight: "400", textAlign: "left", whiteSpace: "normal", minWidth: "280px", width: "280px", wordWrap: "break-word" }}>{item.map_data?.py_map?.note_grp || "-"}</td>
                  <td style={{ color: "#111111", padding: "16px 24px", fontSize: "14px", fontWeight: "400", textAlign: "left", whiteSpace: "normal", minWidth: "320px", width: "320px", wordWrap: "break-word" }}>{item.map_data?.py_map?.sub_grp || "-"}</td>
                </tr>
              ))}
              {coaData.length === 0 && (
                <tr>
                  <td colSpan="14" style={{ textAlign: "center", padding: "60px 20px" }}>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                      <span style={{ fontSize: "16px", fontWeight: "500", color: "#888" }}>Nothing here yet</span>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default Listing;
